// extracted by mini-css-extract-plugin
export default {"button":"FTg2cblhHemTPqmJTJy0"};